import React from "react";
import Footer from "../../common/Footer.js";
import AdminSideNav from "../../common/AdminSideNav.js";
import AnalystSideNav from "../../common/AnalystSideNav.js";
import UnauthorisedPage from "../Unauthorised";
import TopNav from "../../common/TopNav.js";
import { connect } from "react-redux";
import Select from "react-select";
import requireAuth from "../../hoc/requireAuth";
import authorizeAnalystOrAdmin from "../../hoc/authorizeAnalystOrAdmin";
import DateRangePicker from "react-bootstrap-daterangepicker";
import * as moment from "moment";
import "sweetalert/dist/sweetalert.css";
import { withAlert } from "react-alert";
import "../../assets/css/data-upload.css";
import Swal from "sweetalert2/dist/sweetalert2.js";
import debounce from "lodash.debounce";
import { Table } from "react-bootstrap";
import download from "downloadjs";
import Loader from "react-loader-spinner";
import { getInfrigementStatusText } from "../../infrigementStatusCode.js";

class ClientRequest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      authorised: true,
      platform: "",
      showDataSavedAlert: false,
      selectedOption: null,
      companies: [],
      brands: [],
      brandId: [],
      statusCodeOption: [],
      actionDateOption: [],
      selectedReasonCode: "",
      selectedStatus: "",
      selectedActionDate: "",
      startDate: moment().format("DD/MM/YYYY"),
      endDate: moment().format("DD/MM/YYYY"),
      company: "",
      brand: "",
      dataSaveError: {},
      locale: { format: "DD/MM/YYYY" },
      queues: [],
      pagination: {
        page: 1,
        nextPage: 1,
        prevPage: null,
        hasNextPage: true,
        hasPrevPage: false,
        pagingCounter: 1,
        totalDocs: null,
        totalPages: null,
      },
      perPage: 20,
      isLoading: false,
      hasMoreDomainData: true,
      selectedKey: "",
      brandLoading: false,
      statusLoading: false,
      reasonLoading: false,
      sellerLoading: false,
      actionDateLoading: false,
      status: "",
      isDownloading: false,
      hasFetchedOnce: false,
    };
    this.listofRecords = debounce(this.listofRecords.bind(this), 500);
    this.downloadExcel = debounce(this.downloadExcel.bind(this), 500);
    window.onscroll = debounce(() => {
      const {
        listofRecords,
        state: { hasMoreDomainData },
      } = this;

      if (!hasMoreDomainData) {
        return;
      }

      if (
        window.innerHeight + document.documentElement.scrollTop ===
        document.documentElement.offsetHeight
      ) {
        listofRecords();
      }
    }, 100);
  }

  componentDidUpdate(prevProps, prevState) {
    const { company, platform, brandId, startDate, endDate, selectedStatus } =
      this.state;

    const companyChanged = prevState.company !== company;
    const brandIdChanged = prevState.brandId !== brandId;
    const dateChanged =
      prevState.startDate !== startDate || prevState.endDate !== endDate;
    const statusChanged = prevState.selectedStatus !== selectedStatus;
    const platformChanged = prevState.platform !== platform;

    if (companyChanged) {
      this.getBrands();
      this.setState({ brand: [], brandId: [] });
    }
  }

  componentDidMount() {
    this.getCompanies();
    //this.listofRecords();
  }

  async getCompanies() {
    await window.axios
      .get("/company", {
        params: {
          perPage: 100,
        },
      })
      .then((res) => {
        this.setState({
          companies: res.data.docs,
        });
      });
  }

  async getBrands() {
    this.setState({ brandLoading: true });
    await window.axios
      .get("/brand", {
        params: {
          disabledBrands: true,
          company: this.state.company,
          page: 1,
          perPage: 800,
        },
      })
      .then((res) => {
        res.data.docs.push({ brandName: "All" });
        this.setState({
          brands: res.data.docs,
        });
      });

    this.setState({ brandLoading: false });
  }

  async getStatus() {
    this.setState({ statusLoading: true });
    await window.axios
      .get("/services/status", {
        params: {
          company: this.state.company,
          brand: this.state.brandId,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          platform: this.state.platform,
          reasonCode: this.state.selectedReasonCode,
        },
      })
      .then(({ data }) => {
        this.setState({ statusCodeOption: data });
      });
    this.setState({ statusLoading: false });
  }

  async getActionDate() {
    this.setState({ actionDateLoading: true });
    await window.axios
      .get("/services/action-date", {
        params: {
          company: this.state.company,
          brand: this.state.brandId,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          platform: this.state.platform,
          reasonCode: this.state.selectedReasonCode,
          status: this.state.selectedStatus,
        },
      })
      .then(({ data }) => {
        this.setState({ actionDateOption: data });
      });
    this.setState({ actionDateLoading: false });
  }

  async downloadExcel() {
    this.setState({ isDownloading: true });
    let reqData = {
      company: this.state.company,
      brand: this.state.brand,
      platform: this.state.platform,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      status: this.state.status,
    };

    try {
      const response = await window.axios.get("/client-request/excel", {
        params: reqData,
        responseType: "blob",
        timeout: 30000,
      });

      const mimeType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const filename = "client-request.xlsx";
      download(response.data, filename, mimeType);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
      Swal.fire("Download failed. Please try again later.", "", "error");
    } finally {
      // Re-enable buttons after download attempt
      this.setState({ isDownloading: false });
    }
  }

  handleReject = async (queue) => {
    const { value: remarks } = await Swal.fire({
      title: "Reject Request",
      input: "textarea",
      inputLabel: "",
      inputPlaceholder: "Comments...",
      showCancelButton: true,
      confirmButtonText: "Reject",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      inputValidator: (value) => {
        if (!value || value.trim().length < 10) {
          return "Please enter at least 10 characters";
        }
        return null;
      },
    });

    if (!remarks) return;

    try {
      await window.axios.post("/client-request/reject", {
        requestId: queue._id,
        remarks,
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Request mark rejected successfully",
        timer: 1500,
        showConfirmButton: false,
      });

      // Update UI without refetch
      this.setState((prev) => ({
        queues: prev.queues.map((q) =>
          q._id === queue._id
            ? { ...q, status: "Rejected", rejectionRemarks: remarks }
            : q,
        ),
      }));
    } catch (err) {
      Swal.fire("Error", "Failed to reject request", "error");
    }
  };

  async listofRecords(reArrangeRecords = false) {
    let reqData = {
      page: this.state.pagination.nextPage,
      perPage: this.state.perPage,
      company: this.state.company,
      brand: this.state.brand,
      platform: this.state.platform,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      status: this.state.status,
    };

    if (reArrangeRecords) {
      reqData.page = 1;
    }

    this.setState(() => ({ isLoading: true }));

    await window.axios
      .get("/client-request/getRecords", {
        params: reqData,
      })
      .then((res) => {
        let queueData = [...this.state.queues].concat(res.data.docs);

        if (reArrangeRecords) {
          queueData = res.data.docs;
        }

        this.setState(() => ({
          queues: queueData,
          isLoading: false,
          pagination: {
            page: res.data.page,
            nextPage: res.data.nextPage,
            prevPage: res.data.prevPage,
            hasNextPage: res.data.hasNextPage,
            hasPrevPage: res.data.hasPrevPage,
            pagingCounter: res.data.pagingCounter,
            totalDocs: res.data.totalDocs,
            totalPages: res.data.totalPages,
          },
          hasMoreDomainData: res.data.hasNextPage,
          hasFetchedOnce: true,
        }));
      });
  }

  renderLoader() {
    if (this.state.isLoading) {
      return (
        <div className="text-center">
          <Loader
            type="ThreeDots"
            color="#00BFFF"
            height={10}
            width={200}
            timeout={5000} //3 secs
          />
        </div>
      );
    }
  }

  getDateFilters() {
    return {
      startDate: moment(),
      endDate: moment(),
      locale: this.state.locale,
    };
  }

  handleCallback = (date) => {
    const dateArray = date.delegateTarget.value.split(" - ");
    this.setState({ startDate: dateArray[0], endDate: dateArray[1] });
  };

  handleChange = (selectedOptions) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      this.setState({ brand: [], brandId: [] });
      return;
    }

    // Check if "ALL" is selected
    const allSelected = selectedOptions.some(
      (option) => option.label.toUpperCase() === "ALL",
    );

    if (allSelected) {
      this.setState({
        brand: [{ label: "ALL", value: "ALL" }], // Store "ALL" as an object
        brandId: [],
      });
    } else {
      const selectedBrands = selectedOptions.map((option) => option);
      const selectedBrandIds = selectedOptions
        .map((option) => {
          const brand = this.state.brands.find((b) => b.id === option.value);
          return brand ? brand.id : null;
        })
        .filter((id) => id !== null); // Remove null values

      this.setState({
        brand: selectedBrands,
        brandId: selectedBrandIds,
      });
    }
  };

  changePlatformSelectBox(e) {
    let selectedKeyValue = "domainKeys";

    let key = e.target.value;

    if (key === "website") {
      selectedKeyValue = "websiteKeys";
    }
    if (key === "social-media") {
      selectedKeyValue = "socialMediaKeys";
    }
    if (key === "e-commerce") {
      selectedKeyValue = "ecommerceKeys";
    }
    if (key === "app-store") {
      selectedKeyValue = "appStoreKeys";
    }

    this.setState({
      platform: e.target.value,
      selectedKey: selectedKeyValue,
    });
  }

  renderHtml() {
    if (!this.state.authorised) {
      return <UnauthorisedPage />;
    }

    const options = this.state.brands.map((brand, brandKey) => ({
      value: brand.id,
      label: brand.brandName,
    }));

    return (
      <div className="row">
        {this.props?.login?.user?.role === "Admin" ? (
          <AdminSideNav />
        ) : (
          <AnalystSideNav />
        )}

        <main
          id="bulk-data-download-screen"
          className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3"
        >
          <TopNav />

          <div className="main-content-container container-fluid px-4">
            <div className="page-header row no-gutters py-4">
              <div className="col-12">
                <div className="row">
                  <div className="col-12 col-sm-4 text-sm-left mb-0">
                    <span className="text-uppercase page-subtitle">
                      Client Request
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="card card-small mb-4">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <span className="text-muted d-block mb-2">
                              Company
                            </span>
                            <select
                              onChange={(e) => {
                                this.setState({
                                  company: e.target.value,
                                  brand: [],
                                  brandId: [],
                                });
                              }}
                              className="form-control"
                            >
                              <option value="">Select from dropdown</option>
                              {this.state.companies.map(
                                (company, companyIndex) => (
                                  <option key={companyIndex} value={company.id}>
                                    {company.name}
                                  </option>
                                ),
                              )}
                            </select>
                            {this.state.dataSaveError?.company && (
                              <span className="text-danger">
                                {this.state.dataSaveError?.company}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <span className="text-muted d-block mb-2">
                              Brand
                            </span>
                            <select
                              onChange={(e) => {
                                this.setState({
                                  brand: e.target.value,
                                });
                              }}
                              className="form-control"
                            >
                              <option value="">Select from dropdown</option>
                              {this.state.brands.map((brand, brandIndex) => (
                                <option key={brandIndex} value={brand.id}>
                                  {brand.brandName}
                                </option>
                              ))}
                            </select>
                            {this.state.dataSaveError?.company && (
                              <span className="text-danger">
                                {this.state.dataSaveError?.company}
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <span className="text-muted d-block mb-2">
                              Platform
                            </span>
                            <select
                              value={this.state.platform}
                              onChange={(e) => this.changePlatformSelectBox(e)}
                              className="form-control"
                            >
                              <option value="">Select from dropdown</option>
                              {((this.state.availablePlatforms &&
                                this.state.availablePlatforms.domain) ||
                                !this.state.availablePlatforms) && (
                                <option value="domain">Domain</option>
                              )}
                              {((this.state.availablePlatforms &&
                                this.state.availablePlatforms.website) ||
                                !this.state.availablePlatforms) && (
                                <option value="website">Website</option>
                              )}
                              {((this.state.availablePlatforms &&
                                this.state.availablePlatforms.socialMedia) ||
                                !this.state.availablePlatforms) && (
                                <option value="socialMedia">
                                  Social Media
                                </option>
                              )}
                              {((this.state.availablePlatforms &&
                                this.state.availablePlatforms.eCommerce) ||
                                !this.state.availablePlatforms) && (
                                <option value="eCommerce">E-commerce</option>
                              )}
                              {((this.state.availablePlatforms &&
                                this.state.availablePlatforms.appStore) ||
                                !this.state.availablePlatforms) && (
                                <option value="app-store">App Store</option>
                              )}
                            </select>
                            {this.state.dataSaveError?.platform && (
                              <span className="text-danger">
                                {this.state.dataSaveError?.platform}
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label className="form-label text-muted mb-2">
                              Date Range
                            </label>
                            <DateRangePicker
                              onApply={this.handleCallback}
                              initialSettings={this.getDateFilters()}
                              alwaysShowCalendars={true}
                            >
                              <input className="form-control" />
                            </DateRangePicker>
                          </div>
                          {this.state.dataSaveError?.reportingDate && (
                            <div className="text-danger mt-1 small">
                              {this.state.dataSaveError.reportingDate}
                            </div>
                          )}
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="reasonCode">Status</label>
                            <select
                              className="form-control"
                              id="status"
                              value={this.state.status}
                              onChange={(e) => {
                                this.setState({
                                  status: e.target.value,
                                });
                              }}
                            >
                              <option value="">Select</option>
                              <option value="submitted">Active</option>
                              <option value="deferred">Rejected</option>
                              <option value="processed">Resolved</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="form-group">
                            <button
                              onClick={(e) => this.listofRecords(true)}
                              className="mt-4 btn btn-ldotr"
                            >
                              Fetch Data
                            </button>
                          </div>
                        </div>
                        {this.state.queues.length > 0 && (
                          <div className="col-md-3">
                            <div className="form-group">
                              <button
                                onClick={(e) => this.downloadExcel()}
                                className="mt-4 btn btn-ldotr"
                              >
                                Download Excel
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="card card-small mb-4">
                  <div className="card-body p-0">
                    <Table
                      hover
                      width="100%"
                      id="queue-table"
                      className="table mb-0"
                    >
                      <thead className="bg-light uppercase-th">
                        <tr>
                          <th width="3%" scope="col" className="border-0">
                            Sr.
                          </th>
                          <th width="8%" scope="col" className="border-0">
                            Username
                          </th>
                          <th width="10%" scope="col" className="border-0">
                            Company
                          </th>
                          <th width="10%" scope="col" className="border-0">
                            Brand
                          </th>
                          <th width="10%" scope="col" className="border-0">
                            Platform
                          </th>
                          <th width="6%" scope="col" className="border-0">
                            Domain/Url
                          </th>
                          <th width="6%" scope="col" className="border-0">
                            Client Remarks
                          </th>
                          <th width="8%" scope="col" className="border-0">
                            Status
                          </th>
                          <th width="8%" scope="col" className="border-0">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state?.queues.map((queue, key) => (
                          <tr
                            key={key}
                            data-toggle="collapse"
                            data-target={".multi-collapse" + key}
                            aria-controls={"multiCollapseExample" + key}
                          >
                            <td>
                              <p className="mx-0 my-0">{key + 1}</p>
                            </td>
                            <td>
                              <p
                                className="mx-0 my-0 truncate"
                                title={queue.emailId}
                              >
                                {queue.emailId}
                              </p>
                            </td>
                            <td>
                              <p
                                className="mx-0 my-0 truncate"
                                title={queue.company}
                              >
                                {queue.company}
                              </p>
                            </td>
                            <td>
                              <p
                                className="mx-0 my-0 truncate"
                                title={queue.brand}
                              >
                                {queue.brand}
                              </p>
                            </td>
                            <td>
                              <p
                                className="mx-0 my-0 truncate"
                                title={queue.platform}
                              >
                                {queue.platform === "domain"
                                  ? "Domain"
                                  : queue.platform === "website"
                                    ? "Website"
                                    : queue.platform === "socialMedia"
                                      ? "Social Media"
                                      : queue.platform === "eCommerce"
                                        ? "E-commerce"
                                        : queue.platform === "app-store"
                                          ? "App Store"
                                          : ""}
                              </p>
                            </td>
                            <td>
                              <p
                                className="mx-0 my-0 truncate"
                                title={queue.uploadedUrl}
                              >
                                {queue.uploadedUrl}
                              </p>
                            </td>
                            <td>
                              <p
                                className="mx-0 my-0 truncate"
                                title={queue.clientRemarks}
                              >
                                {queue.clientRemarks}
                              </p>
                            </td>
                            <td>
                              <p
                                className="mx-0 my-0 truncate"
                                title={queue.status}
                              >
                                {queue.status}
                              </p>
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.handleReject(queue);
                                }}
                              >
                                Reject
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
                {this.state.hasFetchedOnce && this.state.hasMoreDomainData && (
                  <div className="text-center">
                    <a
                      href="#"
                      className="text-danger"
                      onClick={(e) => this.listofRecords()}
                    >
                      {" "}
                      {this.renderLoader()} Load more...
                    </a>
                  </div>
                )}
                {!this.state.hasMoreDomainData && (
                  <div className="text-center">
                    <label className="text-muted">No more data to show.</label>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* data saved sweet alert */}
          <Footer />
        </main>
      </div>
    );
  }

  render() {
    return <>{this.renderHtml()}</>;
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  login: state.login,
  response: state.response,
});

export default withAlert()(
  connect(mapStateToProps)(authorizeAnalystOrAdmin(requireAuth(ClientRequest))),
);
